import type { useMutation, useQuery } from "@tanstack/react-query";
import { useBeneKey } from "../context-hooks/useBeneKey";
import { QueryKey } from "./types";
import { useMemo } from "react";

export const useBeneinfoProvidersQueryKey = (): Parameters<
  typeof useQuery
>[0]["queryKey"] => {
  const beneKey = useBeneKey();
  return useMemo(() => [QueryKey.BeneinfoProviders, "GET", beneKey], [beneKey]);
};

export const useBeneinfoProvidersMutationKey = (): Parameters<
  typeof useMutation
>[0]["mutationKey"] => {
  const beneKey = useBeneKey();
  return useMemo(
    () => [QueryKey.BeneinfoProviders, "POST", beneKey],
    [beneKey]
  );
};

export const useBeneinfoProviderSearchCentersMutationKey = (): Parameters<
  typeof useMutation
>[0]["mutationKey"] => {
  const beneKey = useBeneKey();
  return useMemo(
    () => [QueryKey.BeneinfoProviderSearchCenters, "POST", beneKey],
    [beneKey]
  );
};

export const useBeneinfoProvidersMapnetQueryKey = (): Parameters<
  typeof useQuery
>[0]["queryKey"] => {
  const beneKey = useBeneKey();
  return useMemo(
    () => [QueryKey.BeneinfoProvidersMapnet, "GET", beneKey],
    [beneKey]
  );
};
